import { render, staticRenderFns } from "./Dados.vue?vue&type=template&id=9fa4d538&scoped=true&"
import script from "./Dados.vue?vue&type=script&lang=js&"
export * from "./Dados.vue?vue&type=script&lang=js&"
import style0 from "./Dados.vue?vue&type=style&index=0&id=9fa4d538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa4d538",
  null
  
)

export default component.exports